//import _ from 'lodash';
import { connect } from 'react-redux';
import { searchRegistry, updateRegistry } from '../modules/registry';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => {

	let registryRows = undefined;

	if (state.registry.registryRows) {
		registryRows = state.registry.registryRows;
	}
	return {
		registryRows,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchRegistry,
	updateRegistry,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
